export default "__VITE_ASSET__db83f467__"